<div class="bina-catalog-search-sidebar">
  <div class="bina-catalog-search-sidebar__header">
    <div class="bina-catalog-search-sidebar__header-text">
      {{ "MENU.BINA_CATALOG" | translate }}
    </div>
    <div class="bina-catalog-search-sidebar__header-close" (click)="close.emit()">×</div>
  </div>

  <div class="bina-catalog-search-sidebar__content">
    <div class="bina-catalog-search-sidebar__content__header" *ngIf="isShowSearch">
      <app-bina-catalog-search
        [isFullWidth]="true"
        [isShowClearButton]="true"
        [companyId]="company.id"
        [initialValue]="prefilledSearch"
        (search)="onSearch($event)"
      ></app-bina-catalog-search>
    </div>

    <div class="bina-catalog-search-sidebar__list" *ngIf="items | async as favoriteHtsNumbers">
      <app-hts-code-card
        *ngFor="let favoriteHts of favoriteHtsNumbers; trackBy: trackById"
        class="bina-catalog-search-sidebar__card"
        [favoriteHtsNumber]="favoriteHts"
        [isShowHoverBackground]="true"
        [isShowInsert]="true"
        [isShowAssistantTag]="isHtsAssistantEnabled"
        [maxDescriptionLines]="2"
        [descriptionCharLimit]="108"
        (insert)="htsInsert.emit(favoriteHts)"
      ></app-hts-code-card>

      <ng-container *ngIf="suggestions | htsSuggestionsWithoutCatalog : favoriteHtsNumbers as visibleSuggestions">
        <ng-container *ngIf="visibleSuggestions.length">
          <div class="bina-catalog-search-sidebar__suggestions-title">{{ "BINA_CATALOG.SUGGESTIONS_TITLE" | translate }}</div>
          <app-hts-code-card
            *ngFor="let suggestion of visibleSuggestions; trackBy: trackBySuggestion"
            class="bina-catalog-search-sidebar__card"
            [suggestion]="suggestion"
            [isShowHoverBackground]="true"
            [isShowInsert]="true"
            [maxDescriptionLines]="2"
            [descriptionCharLimit]="108"
            (insert)="suggestionInsert.emit(suggestion)"
          ></app-hts-code-card>
        </ng-container>
      </ng-container>

      <div class="bina-catalog-search-sidebar__empty" *ngIf="!favoriteHtsNumbers.length && !suggestions.length">
        {{ emptyStateKey | translate }}
      </div>
    </div>

    <button type="button" class="btn btn-link bina-catalog-search-sidebar__show-all" *ngIf="isShowSearch" (click)="showAll()">
      {{ "BINA_CATALOG.SEARCH_ALL_SAVED" | translate }}
    </button>
  </div>
</div>
